/**
 * @ngdoc service
 * @name common.service:SaveForLaterService
 * @description
 * description
 */
(function() {

    'use strict';

    angular
        .module('itxApp.wishlist')
        .service('SaveForLaterService', SaveForLaterService);

    SaveForLaterService.$inject = [
        'WishlistServiceApi',
        'ItxShopCartFct',
        '$q',
        '$rootScope',
        'CmsConfigSvc',
        'Product',
        'ItxLoaderFct',
        'preCommonCmsConfigSvc'
    ];

    function SaveForLaterService(
        WishlistServiceApi,
        ItxShopCartFct,
        $q,
        $rootScope,
        CmsConfigSvc,
        Product,
        ItxLoaderFct,
        preCommonCmsConfigSvc
    ) {

        var _this = this;
        
        _this.buylater = {
            name: 'buylater',
            event: 'buylater:update',
            wishlist: [],
            products: [],
            enabled: false,
            isEmpty: true
        };

        _this.wishEnabled = false;
        
        _this.parseSaveForLater = function (list, forceBroadcast) {
            var deferred = $q.defer();
            let promiseCounter = 0;
            var cacheArrayProducts = [];
            var arrayPromises = [];
            let arrayPromisesClean = [];
            var cacheArrayProductsKey = _.keyBy(_this.buylater.products, 'sku');
            
            if(list && list.items){    
                _this.buylater.wishlist = list.items;
                
                _.each(_this.buylater.wishlist, function (item) {
                    if(item.productId && item.catentryId){
                        if(cacheArrayProductsKey[item.catentryId]){
                            // Si ya tenemos el producto generado lo recuperamos
                            cacheArrayProducts = _.concat(cacheArrayProducts, cacheArrayProductsKey[item.catentryId]);
                        } else {
                            // Si no generamos un new Product()
                            arrayPromises = _.concat(arrayPromises, new Product(item.productId, null, null, null, item.catentryId).fetch());
                        }
                    }
                });

                if(arrayPromises.length > 0){
                    for(let i =0; i<arrayPromises.length; i++){
                        arrayPromises[i]
                            .then(function(list){
                                arrayPromisesClean.push(list);
                                promiseCounter++;
                                if(promiseCounter===arrayPromises.length){
                                    _this.resolveProductPromises(arrayPromisesClean, cacheArrayProducts, forceBroadcast);
                                }
                            })
                            .Catch(function(){
                                promiseCounter++;
                                if(promiseCounter===arrayPromises.length){
                                    _this.resolveProductPromises(arrayPromisesClean, cacheArrayProducts, forceBroadcast);
                                }
                            })
                    }
                } else {
                    _this.buylater.products = cacheArrayProducts;
                    _this.buylater.isEmpty = _this.buylater.products.length === 0;
                    loaderHide();
                    deferred.resolve(_this.buylater); 
                    if(forceBroadcast){
                        broadcastSaveForLater(_this.buylater);
                    }
                }
                
                return deferred.promise;    
            }
        };

        _this.resolveProductPromises = function(arrayPromisesClean, cacheArrayProducts, forceBroadcast){
            let deferred = $q.defer();
            $q.all(arrayPromisesClean).then(function (list) {
                _this.buylater.products = _.concat(cacheArrayProducts, list);
                _this.buylater.isEmpty = _this.buylater.products.length === 0;
                loaderHide();
                deferred.resolve(_this.buylater); 
                if(forceBroadcast){
                    broadcastSaveForLater(_this.buylater);
                }
            });
        }

        var service = {
            isActive: isActive,
            getList: getList,
            addItemList: addItemList,
            deleteItemList: deleteItemList,
            addItemShopcart: addItemShopcart,
            deleteArrayItemsList: deleteArrayItemsList,
            addArrayItemsList: addArrayItemsList
        };

        return service;

        function isActive() {
            checkWishEnabled();
            return CmsConfigSvc.getProperty(_this.buylater.name)
                .then(function(enabled) {
                    _this.buylater.enabled = enabled;
                    return _this.buylater;
                })
                .catch(function () {
                    return _this.buylater;
                });
        }

        function getList(force) {
            return WishlistServiceApi.getWishlist(_this.buylater.name)
            .then(function(list) {
                return _this.parseSaveForLater(list, force);
            });
        }

        /*
         *  @param item = Object ItemSaveForLater
         */
        function deleteItemList(item) {
            ItxLoaderFct.show();
            return WishlistServiceApi.deleteItemWishlist(_this.buylater.name, item)
            .then(function(list) {
                return _this.parseSaveForLater(list);
            });
        }

        /*
         *  @param item = Object item shopcart
         */
        function addItemList(item) {
            // TODO
            if (item && item.state && item.sku) {
                var _item = JSON.parse(JSON.stringify(item));
                _.each(_item.colors, function (color, i) {
                    if (color.id == _item.colorId) {
                        _.each(color.sizes, function (size) {
                            if (size.sku == _item.sku) {
                                _item.selectedColor = color;
                                _item.selectedSize = size;
                            }
                        });
                    }
                });
            }

            ItxLoaderFct.show();
            var objItem = [
                {
                    id: _item.id,
                    quantity: 0
                }
            ];
            WishlistServiceApi.addItemWishlist(_this.buylater.name, _item, _this.wishEnabled)
                .then(function (list) {
                    ItxShopCartFct.updateCart(objItem).then(function () {
                        updateWishlistApollo();
                        return _this.parseSaveForLater(list);
                    });
                })
                .catch(function () {
                    ItxLoaderFct.hide();
                });
        }

        /*
         *  @param item = Object ItemSaveForLater
         */
        function addItemShopcart(item) { 
            ItxLoaderFct.show();
            ItxShopCartFct.addToCart(item, item.state.selectedColor, item.state.selectedSize, item.quantity)
            .then(function() {
                return deleteItemList(item);
            });
        }

        /*
         *  @param forceBroadcast = Boolean
         *  @param arrayItems = Array
         */
        function addArrayItemsList() {
            var deferred = $q.defer();
            ItxLoaderFct.show();
            ItxShopCartFct.deleteItemsOutOfStock()
            .then(function (res) {
                var arrayPromises = [];
                
                _.each(res.itemsRemoved, function (item) {
                    item.quantity = 1;
                    arrayPromises = _.concat(arrayPromises, WishlistServiceApi.addItemWishlist(_this.buylater.name, item, _this.wishEnabled));
                });

                $q.all(arrayPromises).then(function (res) {
                    // if(res && res.length > 0){
                    //     return _this.parseSaveForLater(res[res.length-1]);
                    // } else{
                    //     deferred.resolve('ERROR Promise all buylater');
                    // }

                    updateWishlistApollo();


                    var forceBroadcast = true;
                    return getList(forceBroadcast);
                });
            });
            return deferred.promise;
        }

        /*
         *  @param forceBroadcast = Boolean
         *  @param arrayItems = Array
         */
        function deleteArrayItemsList() {
            var deferred = $q.defer();
            
            service.getList().then(function(wishlist) {
                var arrayItems = _.each(wishlist.items, function (item) {
                    item.quantity = -item.quantity;
                    return item;
                });
                
                var promises = [];
                _.each(arrayItems, function (item) {
                    promises = _.concat(promises, WishlistServiceApi.deleteItemWishlist(_this.buylater.name, item));
                });
                
                $q.all( promises )
                .then(function(list) {
                    return _this.parseSaveForLater(list, true);
                });
            });

            return deferred.promise;
        }

        // PRIVATE FUNCTIONS
        function broadcastSaveForLater(buylater) {
            $rootScope.$broadcast(_this.buylater.event, buylater);
        }
        
        function loaderHide() {
            setTimeout(function(){
                ItxLoaderFct.hide();
            }, 250);
        }

        function updateWishlistApollo() {
            if(_this.wishEnabled) {
                    const options = {
                        bubbles: true,
                        composed: true,
                        detail: {
                            extra: {
                                typeEvent: 'buylater-add-item'
                            }
                        }
                    };
                    document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
            }
        }

        function checkWishEnabled() {
            preCommonCmsConfigSvc
            .getProperty('enable_wishlist')
            .then(function (wishEnabled) {
                if (wishEnabled) {
                    _this.wishEnabled = true;
                }
            })
            .catch(function (err) {
                console.error('Error getting CMS key: enable_wishlist ');
            });
        }

        
    }

})();
